import localforage from "localforage";

export function init() {
  localforage.config({
    driver: localforage.WEBSQL,
    name: "c2sgo",
    version: 1.0,
    storeName: "c2sgo",
  });
}
